import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { UtilsProvider } from '../../providers/utils/utils';
import { SimuladorCuentasPorCobrarProvider } from '../../providers/simulador-cuentas-por-cobrar/simulador-cuentas-por-cobrar';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { CajaProvider } from '../../providers/caja/caja';
import { NUBE_AWS } from '../../config/url.servicio';
import { ChangeDetectorRef } from '@angular/core';

@IonicPage()
@Component({
  selector: 'page-simulador-cuentas-por-cobrar',
  templateUrl: 'simulador-cuentas-por-cobrar.html',
  providers: [
    SimuladorCuentasPorCobrarProvider,CajaProvider
  ]
})
export class SimuladorCuentasPorCobrarPage {
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  numeroDeCuotas = 1
  valorCuotaString = "0"
  montoDeLaCuotaString = "0"
  valorCuota = 0
  montoDeLaCuota = 0
  periodicidad: string = 'm'
  peridoDeGracia = 0
  diaDePago = 0
  cuotasExtras = 0
  costosAdicionales = 0
  numeroDeCuotaExtrasReal = 0
  planDePagos: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  clienteId = []
  valoresCliente: string = '';
  cuotasExtrasArray: any[] = [];
  costosAdicionalesArray: any[] = [];
  guardarPlanDePagosEnCuentasPorCobrarSimulador: boolean = false;
  interesCreditos: any[] = [];
  companiasId:any = 0
  index:any= 0
  planDePagosConCostosAdicionales: any[] = []
  costosAdicionalesHeaders: any[] = []
  costosAdicionalesHeader = [];
  tasaPeriodica = 0
  tasaEfectivaAnual = 0
  manejaInteresCreditos = false
  planDePagosConCostosAdicionalesCalculados: any[] = []
  costosAdicionalesDiaDePago: any[] = []
  costosAdicionalesRecalcular: any[] = []
  planSepare: string = 'N';
  planSepareTexto: string = 'No';
  CheckPlanSepare: boolean = false;
  selectedValue = []
  fechaDiaDePago: string ='1900-01-01'
  diaDePagoBoolean: boolean = false
  exonerar:string = 'N'
  exoneradoNumeroCuotas: number = 0
  descripcionVenta:string = ""
  cupo = 0
  interesesCorrientesVisualizarPlanDePagos: boolean = false;
  interesesMoraVisualizarPlanDePagos: boolean = false;
  capitalAtrasadoVisualizarPlanDePagos: boolean = false;
  costosAdicionalesVisualizarPlanDePagos: boolean = false;
  fechaVisualizarPlanDePagos: boolean = false;
  visualizaDiaDePago: boolean= false;
  visualizaExonerarInteresPrimeraCuota: boolean= false;
  visualizaNumeroDeCuotasExoneradas: boolean= false;
  montoDeLaCuotaVisualizar: boolean= false;
  montoDeLaCuotaConCostosEintereses: boolean= false;
  cuantoRestaEnLaCuota: boolean= false;
  storageCreditos:any
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewControllers:ViewController, public utils:UtilsProvider,
    public simuladorCuentasPorCobrarProvider: SimuladorCuentasPorCobrarProvider,
  public cajaProvider:CajaProvider,private cdr: ChangeDetectorRef) {
    if(this.navParams.get('data')){
      this.periodicidad = 'm'
      this.listaProductosSeleccionados = this.navParams.get('data')
      this.valorTotalVenta = this.navParams.get('valorTotalVenta')
      this.clienteId = this.navParams.get('clienteId')
      this.companiasId = this.navParams.get('companiasId')
      this.index = this.navParams.get('index')
      this.cupo = this.navParams.get('cupo')
      this.interesesCorrientesVisualizarPlanDePagos = this.navParams.get('interesesCorrientesVisualizarPlanDePagos')
      this.interesesMoraVisualizarPlanDePagos = this.navParams.get('interesesMoraVisualizarPlanDePagos')
      this.capitalAtrasadoVisualizarPlanDePagos = this.navParams.get('capitalAtrasadoVisualizarPlanDePagos')
      this.costosAdicionalesVisualizarPlanDePagos = this.navParams.get('costosAdicionalesVisualizarPlanDePagos')
      this.fechaVisualizarPlanDePagos = this.navParams.get('fechaVisualizarPlanDePagos')
      this.visualizaDiaDePago = this.navParams.get('visualizaDiaDePago');
      this.visualizaExonerarInteresPrimeraCuota = this.navParams.get('visualizaExonerarInteresPrimeraCuota');
      this.visualizaNumeroDeCuotasExoneradas = this.navParams.get('visualizaNumeroDeCuotasExoneradas')
      this.montoDeLaCuotaVisualizar = this.navParams.get('montoDeLaCuota')
      this.montoDeLaCuotaConCostosEintereses = this.navParams.get('montoDeLaCuotaConCostosEintereses')
      this.cuantoRestaEnLaCuota= this.navParams.get('cuantoRestaEnLaCuota')
      console.log(this.cuantoRestaEnLaCuota)
      if(this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        this.valoresCliente = this.clienteId[0].display
        this.valorCuota = this.valorTotalVenta
        this.valorCuotaString = this.valorTotalVenta.toString()
        this.diaDePago = new Date().getDate()
        this.registrosIniciales()
        this.buscarIntereses(this.companiasId,this.valorCuota,12)
        } else {
          this.utils.mensajeMuestro('simulador','Debe seleccionar un cliente para poder generar una simulación','warning')
          this.dismiss();
      }
     }
  }

  ngOnInit() {
  }

  async initializePlanDePagos() {
  try {
   let planDePagos = await this.simuladorCuentasPorCobrarProvider.calcularPlanDePagosConInteresesYCostosAdicionales(
      10000, 500, 12, 'm', 2, [], 0.12, [
        {nombre: 'Seguro', valor: 100},
        {nombre: 'Administrativo', valor: 50}
      ]
    );
    this.planDePagosConCostosAdicionales = planDePagos
    if (this.planDePagosConCostosAdicionales.length > 0) {
      const sampleCuota = this.planDePagosConCostosAdicionales[0];
      this.costosAdicionalesHeaders = sampleCuota.costosAdicionales.map(costo => costo.nombre);
     }
   } catch (error) {
      console.error('Error al calcular el plan de pagos', error);
    }
  }

  async registrosIniciales() {
    await this.calcularPlanDePagos(this.valorCuota, this.numeroDeCuotas)
  }

  buscarIntereses(companiasId:any, valorCuota:any,periodicidad:any = 0){
    if(periodicidad === 0) {
      return
    }
    this.cajaProvider.buscarIntereses(companiasId).subscribe(async (data: any)=>{
      if(NUBE_AWS) {
        let responsedata = JSON.parse(data['_body']).data[0]
        if(responsedata.length>0) {

          this.planDePagosConCostosAdicionalesCalculados = JSON.parse(data['_body']).data[1]
          this.costosAdicionalesDiaDePago = JSON.parse(data['_body']).data[2]
          this.interesCreditos = responsedata
          const interesCreditosConCuota = this.interesCreditos.map(ic => {
            let valorAdicional = 0;
            this.planDePagosConCostosAdicionalesCalculados.forEach(p => {
              if (p.numeroCuota === ic.numeroCuota) {
                if (p.tipo === 'P') {
                  valorAdicional += (p.valorcostosadicional / 100) * valorCuota;
                } else if (p.tipo === 'V') {
                  valorAdicional += p.valorcostosadicional;
                }
              }
            });

            let valorCuotaCalculado = this.calcularValorCuota(ic, valorCuota, periodicidad) + valorAdicional;
            if (!isFinite(valorCuotaCalculado) || isNaN(valorCuotaCalculado)) {
              valorCuotaCalculado = 0; // Manejar casos donde el valor es Infinity o NaN
            }

            return {
              ...ic,
              valorCuota: valorCuotaCalculado.toFixed(2) // Redondear a 2 decimales
            };
          });
          this.interesCreditos = []
          const interesCreditosFiltrados = interesCreditosConCuota.filter(ic => parseFloat(ic.valorCuota) < this.cupo);
          this.interesCreditos = interesCreditosFiltrados;
          if(this.interesCreditos.length === 0 ) {
            this.utils.mensajeMuestro('simulador','No se encontraron intereses de crédito disponibles. para el cupo del cliente  ','warning')
            this.dismiss();
            return
          }
        }
      }
    },(error)=> console.log(error))
  }

  async onCuotaChangeSelect(event: any) {
    const selectedValue = event;
    let cantidad = Number(selectedValue.numeroCuota)
    let cuotas = Number(cantidad)
    this.cuotasExtrasArray = []
    this.cuotasExtras = 0
    this.costosAdicionalesRecalcular = []
    if (this.planDePagosConCostosAdicionalesCalculados.length>0) {
        this.costosAdicionalesRecalcular = this.planDePagosConCostosAdicionalesCalculados.filter((item)=>item.numeroCuota === selectedValue.numeroCuota)
    }
    const periodicidad = this.simuladorCuentasPorCobrarProvider.devolverNumeroDePeriodicidad(this.periodicidad);
    this.selectedValue = []
    this.selectedValue.push(selectedValue)
    if(this.planSepare === 'S') {
      this.costosAdicionalesRecalcular = []
    }
    await this.calcularPlanDePagosConIntereses(selectedValue, this.valorCuota, this.costosAdicionalesRecalcular, periodicidad)
    this.diaDePago = 0
    this.fechaDiaDePago = '1900-01-01'
  }

  dismiss(){
    this.viewControllers.dismiss([this.listaProductosSeleccionados]);
  }

  submit(){
   this.viewControllers.dismiss([this.listaProductosSeleccionados]);
  }
  seleccionarElementoCheck(elemento: any, index: any) {
    this.listaProductosSeleccionados[index].color = '#1E078E'
   }

  searchSimple(cantidadNueva:any){
    setTimeout(async () => {
        let cantidadafnSimpleConvert: any = cantidadNueva !== undefined && cantidadNueva.value !== undefined ? cantidadNueva.value : ''
        const valorSinComas = cantidadafnSimpleConvert.replace(/,/g, '');

        // Convertir la cadena a un número
        let cantidadafnSimple = parseInt(valorSinComas, 10);
        if(Number(cantidadafnSimple)==0 || isNaN(cantidadafnSimple) ){
         return
       }

       let cantidadInput = cantidadafnSimple;

        if (isNaN(cantidadInput)) {
          cantidadInput = 0;
          cantidadafnSimple = 0;
          return
        }

       let cantidad = Number(cantidadafnSimple)

       let nuevaCantidad = Number(cantidad)
       this.cuotasExtrasArray = []
       this.cuotasExtras = 0
       await this.calcularPlanDePagos(nuevaCantidad, this.numeroDeCuotas)
       return

     },1000)
   }


   searchSimpleCuotas(cantidadafnSimple:any){
    setTimeout(async () => {
        if(cantidadafnSimple!== undefined && cantidadafnSimple.value !== undefined && Number(cantidadafnSimple.value)==0 || isNaN(cantidadafnSimple.value) ){
         return
       }

       let cantidadInput = cantidadafnSimple.value;

        if (isNaN(cantidadInput)) {
          cantidadInput = 0;
          return
        }

       let cantidad = Number(cantidadInput)

       let cuotas = Number(cantidad)
       this.cuotasExtrasArray = []
       this.cuotasExtras = 0
        let calcularValorSegunPeriodicidad = this.calcularValorSegunPeriodicidad()
        if(!calcularValorSegunPeriodicidad) {
         return
        } else {
         await this.calcularPlanDePagos(this.valorCuota,cuotas)
         return
        }


     },1000)
   }

   searchSimplePeriodoDeGracia(cantidadafnSimple:any){
    setTimeout(async () => {
        if(cantidadafnSimple!== undefined && cantidadafnSimple.value !== undefined && Number(cantidadafnSimple.value)==0 || isNaN(cantidadafnSimple.value) ){
          this.peridoDeGracia = 0
          await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
          return
       }

       let cantidadInput = cantidadafnSimple.value;

        if (isNaN(cantidadInput)) {
          cantidadInput = 0;
          return
        }

       let cantidad = Number(cantidadInput)

       let cuotas = Number(cantidad)
       this.cuotasExtrasArray = []
       this.cuotasExtras = 0
       let calcularValorSegunPeriodicidad = this.calcularValorSegunPeriodoDeGraciaYPeriodicidad(cuotas)
       if(!calcularValorSegunPeriodicidad) {
        return
       } else {
        this.peridoDeGracia = cuotas
        await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
        return
       }
     },1000)
   }

   searchSimpleCuotasExtras(cantidadafnSimple:any){
    setTimeout(async () => {
        if(cantidadafnSimple!== undefined && cantidadafnSimple.value !== undefined && Number(cantidadafnSimple.value)==0 || isNaN(cantidadafnSimple.value) ){
         return
       }

       let cantidadInput = cantidadafnSimple.value;

        if (isNaN(cantidadInput)) {
          cantidadInput = 0;
          return
        }

       let cantidad = Number(cantidadInput)

       let cuotasExtras = Number(cantidad)


       if(cuotasExtras > this.numeroDeCuotas) {
        this.utils.mensajeMuestro('simulador','Las cuotas extras no pueden super :  ' + this.numeroDeCuotas + ' cuotas','warning')
        this.cuotasExtras = 0
        return
       } else {
        this.planDePagos.next([]);
        await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
        this.gestionarCuotasExtras(cuotasExtras)
        return
       }
     },1000)

   }


   searchSimpleformatCuotasExtras(cantidadNueva:any){
     setTimeout(async () => {
         let cantidadafnSimpleConvert: any = cantidadNueva !== undefined && cantidadNueva.value !== undefined ? cantidadNueva.value : ''
         const valorSinComas = cantidadafnSimpleConvert.replace(/,/g, '');
         console.log(valorSinComas)
     })
    }

   async searchSimpleCuotasExtrasArray(){
      let planpagos: any = await this.simuladorCuentasPorCobrarProvider.calcularPlanDePagos(
      this.valorTotalVenta,
      this.valorCuota,
      this.numeroDeCuotas,
      this.periodicidad,
      this.peridoDeGracia,
      this.cuotasExtrasArray

      )

      this.cuotasExtrasArray.sort((a, b) => a.numeroDeCuotaExtrasReal - b.numeroDeCuotaExtrasReal);

      for (let item = 0; item < this.cuotasExtrasArray.length;item++) {

        let numeroDeCuotaExtrasReal = Number(this.cuotasExtrasArray[item].numeroDeCuotaExtrasReal)
        if(numeroDeCuotaExtrasReal > this.numeroDeCuotas) {
          this.utils.mensajeMuestro('simulador','El número de la cuota extra ' + numeroDeCuotaExtrasReal +   ' no puede super el valor de:  ' + this.numeroDeCuotas ,'warning')
          this.cuotasExtrasArray =  []
          this.cuotasExtras = 0
          await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
          item = this.cuotasExtrasArray.length + 1
          return
        }
        if(numeroDeCuotaExtrasReal === 1 ) {
          this.utils.mensajeMuestro('simulador','El número de la cuota extra ' + numeroDeCuotaExtrasReal +   ' no puede estar en la primera cuota  ','warning')
          this.cuotasExtrasArray =  []
          this.cuotasExtras = 0
          await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
          item = this.cuotasExtrasArray.length + 1
          return
        }
        let posicionCuotaReal = numeroDeCuotaExtrasReal === 0 ? 0 : numeroDeCuotaExtrasReal - 1
        if(Number(this.cuotasExtrasArray[item].montoDeLaCuota) > Number(planpagos[posicionCuotaReal].capitalRestante)) {
          this.utils.mensajeMuestro('simulador','El valor de la cuota extra no puede ser súperior a ' + planpagos[posicionCuotaReal].capitalRestante + ' Verifique','warning')
          this.cuotasExtrasArray =  []
          this.cuotasExtras = 0
          await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
          item = this.cuotasExtrasArray.length + 1
          return
        }

        if(Number(numeroDeCuotaExtrasReal) === planpagos.length) {
          this.utils.mensajeMuestro('simulador','El número de la cuota extra ' + numeroDeCuotaExtrasReal +   ' no puede ser igual a las cuotas','warning')
          this.cuotasExtrasArray =  []
          this.cuotasExtras = 0
          await this.calcularPlanDePagos(this.valorCuota,this.numeroDeCuotas)
          item = this.cuotasExtrasArray.length + 1
          return
        }
        let numeroDeCuotaExtrasRealFor = this.cuotasExtrasArray[item].numeroDeCuotaExtrasReal
        let valorCuotaExtraFor = this.cuotasExtrasArray[item].montoDeLaCuota
        if(this.cuotasExtrasArray[item].numeroDeCuotaExtrasReal> 0) {
          let planDePagosResult = this.simuladorCuentasPorCobrarProvider.validarCuotasExtras(
            this.valorTotalVenta,
            this.valorCuota,
            valorCuotaExtraFor,
            numeroDeCuotaExtrasRealFor,
            this.cuotasExtrasArray,
            planpagos,
            this.peridoDeGracia)
            this.planDePagos.next(planDePagosResult);
        }

      }

   }


   buscarIndex(item:any,index:any,nuevaValor: number){
    let id  = Number(index)

    let tipoProducto  = item['tipoProducto']
    let productosId = item['productosId']
    let indexNuevo = 0
    for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
      if(this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto){

      } else {
      }
      }
    return indexNuevo
  }
  async ionViewDidLoad() {
    const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    element.style.height = '100%';
    element.style.width = '100%';
    element.style.top = '0';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';

    this.storageCreditos = await this.getDatosCreditos();

      if (this.storageCreditos) {
        console.log('Datos obtenidos:', this.storageCreditos);
      } else {
        console.log('No hay datos almacenados');
      }
      let datosCreditos = localStorage.getItem('datosCreditos')
      let datosCredito = JSON.parse(datosCreditos)

      if(datosCredito && datosCredito["visualizaDiaDePago"]) {
        this.visualizaDiaDePago = datosCredito["visualizaDiaDePago"].seleccion === 'S' ? true : false
      }

      if(datosCredito && datosCredito["visualizaExonerarInteresPrimeraCuota"]) {
        this.visualizaExonerarInteresPrimeraCuota = datosCredito["visualizaExonerarInteresPrimeraCuota"].seleccion === 'S' ? true : false
      }

      if(datosCredito && datosCredito["visualizaNumeroDeCuotasExoneradas"]) {
        this.visualizaNumeroDeCuotasExoneradas = datosCredito["visualizaNumeroDeCuotasExoneradas"].seleccion === 'S' ? true : false
      }

      if (datosCredito && datosCredito["visualizaEnSimulacion"]) {
        datosCredito["visualizaEnSimulacion"].opciones.forEach(opcion => {
          const key = opcion.key;
          const value = opcion.value[0].visualiza === 'S'; // Asumiendo que solo necesitas el primer valor

            switch (key) {
              case 'interesesCorrientes':
                this.interesesCorrientesVisualizarPlanDePagos = value;
                break;
              case 'interesesMora':
                this.interesesMoraVisualizarPlanDePagos = value;
                break;
              case 'capitalAtrasado':
                this.capitalAtrasadoVisualizarPlanDePagos = value;
                break;
              case 'costosAdicionales':
                this.costosAdicionalesVisualizarPlanDePagos = value;
                break;
              case 'fecha':
                this.fechaVisualizarPlanDePagos = value;
                break;
              case 'montoDeLaCuota':
                  this.montoDeLaCuotaVisualizar = value;
                break;
              case 'montoDeLaCuotaConCostosEintereses':
                  this.montoDeLaCuotaConCostosEintereses = value;
                break;
              case 'cuantoRestaEnLaCuota':
                  this.cuantoRestaEnLaCuota = value;
                break;
              default:
                break;
            }
          });
        }
  }

  calcular(){

  }
  gestionarCuotasExtras(cuotasExtras: number) {
    this.generarCuotasExtras(cuotasExtras)

  }

  generarCuotasExtras(valor: number) {
    this.cuotasExtrasArray = []
    for (let i = 1; i <= valor; i++) {
      this.cuotasExtrasArray.push({ numeroDeCuota: i, montoDeLaCuota: 0, numeroDeCuotaExtrasReal:0 });
    }
  }

  DECIMAL_SEPARATOR  = '.'
  GROUP_SEPARATOR = ','

  format(valString) {
    if (!valString) {
        this.valorCuota = 0
        return '';
    }
    let val = valString.toString();
    try {
        this.valorCuota = Number(val.replace(/,/g, ''))
    } catch (e) {
        this.valorCuota = 0
    }

    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
};

unFormat(val) {
    if (!val) {
        return '';
    }
    val = val.replace(/^0+/, '');

    if (this.GROUP_SEPARATOR === ',') {
        return val.replace(/,/g, '');
    } else {
        return val.replace(/\./g, '');
    }
};



DECIMAL_SEPARATOR_CUOTAS_EXTRAS  = '.'
GROUP_SEPARATOR_CUOTAS_EXTRAS = ','

formatCuotasExtras(valString) {
  if (!valString) {
      this.valorCuota = 0
      return '';
  }
  let val = valString.toString();
  try {
      this.montoDeLaCuota = Number(val.replace(/,/g, ''))
  } catch (e) {
      this.montoDeLaCuota = 0
  }

  const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR_CUOTAS_EXTRAS);
  return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR_CUOTAS_EXTRAS) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR_CUOTAS_EXTRAS + parts[1]);
};

unFormatCuotasExtras(val) {
  if (!val) {
      return '';
  }
  val = val.replace(/^0+/, '');

  if (this.GROUP_SEPARATOR === ',') {
      return val.replace(/,/g, '');
  } else {
      return val.replace(/\./g, '');
  }
};

async onPeriodicidadChange(event: any) {
  this.cuotasExtras = 0
  this.cuotasExtrasArray= [];
  let calcularValorSegunPeriodicidad = this.calcularValorSegunPeriodicidad()
    if(!calcularValorSegunPeriodicidad) {
      return
    } else {
      await this.calcularPlanDePagos(this.valorCuota, this.numeroDeCuotas)
    }
  }

  async onDiaDePagoChange(event: any) {
    try {
      await this.calcularPlanDePagos(this.valorCuota, this.numeroDeCuotas)
      const value = await this.planDePagos.pipe(first()).toPromise();
      let planDePagosTemporal = value
      let plandePagosNuevo = this.simuladorCuentasPorCobrarProvider.cambiarFechaDiaDePago(this.diaDePago,planDePagosTemporal)
      this.planDePagos.next(plandePagosNuevo)
    } catch (error) {
      console.error('Error al obtener el valor del BehaviorSubject', error);
    }
  }

  async calcularValorSegunPeriodicidad() {
    let calcularValorSegunPeriodicidad = this.simuladorCuentasPorCobrarProvider.calcularValorSegunPeriodicidad(this.periodicidad)
    if(this.numeroDeCuotas > calcularValorSegunPeriodicidad) {
     let nombrePeriodo = this.simuladorCuentasPorCobrarProvider.devolverNombrePeriodicidad(this.periodicidad)
     this.utils.mensajeMuestro('simulador','La cantidad de cuotas son superiores a:  ' + calcularValorSegunPeriodicidad + ' cuotas para el periodo ' + nombrePeriodo,'warning')
     this.numeroDeCuotas = 1
     await this.calcularPlanDePagos(this.valorCuota, this.numeroDeCuotas)
     return false
    } else {
    return true
    }
  }

  async calcularValorSegunPeriodoDeGraciaYPeriodicidad(periodoDeGracia:number) {
    let cuotas = this.simuladorCuentasPorCobrarProvider.calcularValorSegunPeriodicidad(this.periodicidad)
    if( cuotas - 1 <= periodoDeGracia) {
     let nombrePeriodo = this.simuladorCuentasPorCobrarProvider.devolverNombrePeriodicidad(this.periodicidad)
     let cuotasMenosUno = cuotas - 1
     this.utils.mensajeMuestro('simulador','El periodo de gracia no puede super :  ' + cuotasMenosUno + ' cuotas para el periodo ' + nombrePeriodo,'warning')
     this.numeroDeCuotas = 1
     this.peridoDeGracia = 0
     await this.calcularPlanDePagos(this.valorCuota, this.numeroDeCuotas)
     return false
    } else {
    return true
    }
  }

  async calcularPlanDePagos(valorCuota: number, numeroDeCuotas: number, interes: number = 0) {
    let planDePagos:any = await this.simuladorCuentasPorCobrarProvider.calcularPlanDePagos(this.valorTotalVenta,valorCuota,numeroDeCuotas,this.periodicidad,this.peridoDeGracia, this.cuotasExtrasArray)
    this.planDePagos.next(planDePagos);
  }

  async calcularPlanDePagosConIntereses(datos:any, valorTotalVenta:any, costosAdicionales:any,periodicidad:any,diaDePago:number = 0) {
    let planDePagos:any = this.interesCreditos.filter((values=> values.numeroCuota == datos.numeroCuota))
    // Calcular el total del capital más los intereses
    const totalCapitalMasInteres = planDePagos.reduce((acc, cuota) => {
      return acc + cuota.valorCuota * cuota.numeroCuota ;
    }, 0);
    let lacuota = 0
    let valoresNuevos:any = await this.simuladorCuentasPorCobrarProvider.calcularPlanDePagosConCostosAdicionales(valorTotalVenta,
      datos,this.listaProductosSeleccionados, costosAdicionales,periodicidad, diaDePago,this.costosAdicionalesDiaDePago,this.planSepare
    )
    let item = this.listaProductosSeleccionados[this.index]
    this.buscarIndexInteres(item,this.index,lacuota)

    this.valorTotalVenta = 0
    let posicion = valoresNuevos.length - 1
    this.valorTotalVenta = valoresNuevos[posicion].totalPagado

    const exclusionKeys: string[] = [
      'numeroDeCuota',
      'montoDeLaCuota',
      'abonoCapital',
      'abonoInteres',
      'fechaDeVencimiento',
      'capitalRestante',
      'totalPagado',
      'tipo',
      'tasaPeriodica',
      'tasaEfectivaAnual'
    ];
    this.costosAdicionalesHeaders = Object.keys(valoresNuevos[0])
    .filter((key: string) => exclusionKeys.indexOf(key) === -1);

    if(this.planSepare === 'S') {
      this.costosAdicionalesHeaders = []
    }
    const nuevoPlanDePagos = this.calcularNuevoPlanDePagos(this.costosAdicionalesHeaders, valoresNuevos);

    this.valorTotalVenta =  nuevoPlanDePagos[nuevoPlanDePagos.length - 1].totalPagado;
    let diaDePagoComparar = new Date().getDate()
    if(this.diaDePago!==0 && diaDePagoComparar !== this.diaDePago && nuevoPlanDePagos.length>0) {
      let fechaDiaDePago = nuevoPlanDePagos[0].fechaDeVencimiento
      this.fechaDiaDePago = new Date(fechaDiaDePago).toISOString().slice(0, 10);
      this.diaDePagoBoolean = true
    }
    // Asigna el nuevo plan de pagos al observable o a la variable correspondiente
    this.planDePagos.next(nuevoPlanDePagos);
    this.cdr.detectChanges();
  }

 calcularNuevoPlanDePagos(
  costosAdicionalesHeaders: string[],
  valoresNuevos: any[]): any[] {

  let totalCostosAdicionalesSumatoria = 0;
  // Actualizar cada cuota con los costos adicionales
  const cuotasActualizadas = valoresNuevos.map((cuota) => {

    let totalCostosAdicionales = 0;

    this.costosAdicionalesRecalcular.forEach((header) => {
      if (cuota[header['nombrecostoadicional']] !== undefined) {
        if (header.tipo === 'P') {
          const montoDeLaCuotaSinInteres = (cuota.montoDeLaCuota || 0) - (cuota.abonoInteres || 0);
          totalCostosAdicionales += (montoDeLaCuotaSinInteres * header.montoDeLaCuota) / 100;
        } else if (header.tipo === 'V') {
          totalCostosAdicionales += header.montoDeLaCuota;
        }
      }
    });
    totalCostosAdicionalesSumatoria += totalCostosAdicionales

      // Devolver la nueva cuota con los costos adicionales sumados y los abonos actualizados
    return {
      ...cuota,
      montoDeLaCuotaConCostos: cuota.montoDeLaCuota + totalCostosAdicionales,
      totalPagado: cuota.totalPagado + totalCostosAdicionalesSumatoria
    };
  });

  // Devolver solo el plan de pagos actualizado
  return cuotasActualizadas;
}


  guardar(){
    this.manejaInteresCreditos = this.interesCreditos.length> 0 ? true: false
    let costosAdicionalesHeaders = []
    let registrosRepetidos = [];
    let registrosOrdenados = []
    let updatedRegistros = []
    let datosAdicionalesCreditos = []
    if(this.manejaInteresCreditos) {
      costosAdicionalesHeaders = this.costosAdicionalesHeaders
      this.costosAdicionalesRecalcular.forEach(costo => {
          for (let i = 0; i < costo.numeroCuota; i++) {
              registrosRepetidos.push({ ...costo });
          }
      });

    registrosOrdenados = registrosRepetidos.sort((a, b) => a.costosadicionalesid - b.costosadicionalesid);

    let currentCostId = null;
    let currentIndex = 0;
    let plandepagos = this.planDePagos.getValue()
    let montoDeLaCuota = 0
    if(plandepagos.length>0 && registrosOrdenados.length>0) {
      montoDeLaCuota = plandepagos[0].montoDeLaCuota
    }
    if(plandepagos.length>0) {
      datosAdicionalesCreditos.push({
        tasaPeriodica: plandepagos[0].tasaPeriodica,
        tasaEfectivaAnual:plandepagos[0].tasaEfectivaAnual,
        periodicidad: 'M',
        planSepare: this.planSepare,
        fechaDiaDePago: this.fechaDiaDePago,
        diaDePago: this.diaDePagoBoolean,
        exonerado: this.exonerar === 'S' ? true : false,
        cuota: this.exoneradoNumeroCuotas,
        descripcion: this.descripcionVenta
       })
    }
    updatedRegistros = registrosOrdenados.map((registro) => {
        if (registro.costosadicionalesid !== currentCostId) {
            currentCostId = registro.costosadicionalesid;
            currentIndex = 1; // Reinicia el contador al cambiar de ID
        } else {
            currentIndex++;
        }
        return {
            ...registro,
            numerodecuota: currentIndex,
            montoDeLaCuota:registro.tipo === 'P' ?
            (montoDeLaCuota * registro.montoDeLaCuota) / 100 : registro.montoDeLaCuota
        };
    });
    this.descripcionVenta = ""
  }
  this.viewControllers.dismiss([{planDePagos:this.planDePagos.getValue(),valorTotal:this.valorTotalVenta,
    listaProductosSeleccionados:this.listaProductosSeleccionados,
    manejaInteresCreditos: this.manejaInteresCreditos,
    costosAdicionalesHeaders:updatedRegistros,
    datosAdicionalesCreditos: datosAdicionalesCreditos
}]);
}

  buscarIndexInteres(item:any,index:any,nuevaValor: number){
    let id  = Number(index)

    item = this.listaProductosSeleccionados[index]

    let tipoProducto  = item['tipoProducto']
    let productosId = item['productosId']
    let indexNuevo = 0
    let valorVentasTotalProductoNuevo = 0
    let ValorProductoVentas = 0
    let ValorSumoImpuesto = 0
    return indexNuevo
  }

//   calcularValorCuota(interesCredito: any, valorPrestamo: any, periodicidad:any) {
//     const tasaEfectivaAnual = interesCredito.valor / 100; // TEA proporcionada en el objeto monto
//     const numeroDeCuotas = interesCredito.numeroCuota;

//     // Convertir TEA a tasa nominal periódica
//     const tasaInteresPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;
//     this.tasaPeriodica = tasaInteresPeriodica
//     this.tasaEfectivaAnual = tasaEfectivaAnual
//     // Calcula el valor de la cuota usando la fórmula de amortización
//     const cuota = valorPrestamo * (tasaInteresPeriodica / (1 - Math.pow(1 + tasaInteresPeriodica, - numeroDeCuotas)));

//     // Redondea la cuota al múltiplo de 100 más cercano
//     return Math.ceil(cuota / 100) * 100;
// }
calcularValorCuota(interesCredito: any, valorPrestamo: any, periodicidad: any) {
  let tasaEfectivaAnual = interesCredito.valor / 100; // TEA proporcionada en el objeto monto
  let tasaInteresPeriodica: number;
  const numeroDeCuotas = interesCredito.numeroCuota;
  // Si el plan es "Separe", no se cobra interés
  if (this.planSepare === 'S') {
      tasaEfectivaAnual = 0; // Sin interés
      tasaInteresPeriodica = 0; // Sin interés
  } else {
      // Convertir TEA a tasa nominal periódica
      tasaInteresPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;
  }

  this.tasaPeriodica = tasaInteresPeriodica;
  this.tasaEfectivaAnual = tasaEfectivaAnual;

  // Calcula el valor de la cuota usando la fórmula de amortización solo si hay interés
  let cuota;
  if (tasaInteresPeriodica === 0) {
      // Si no hay interés, simplemente dividir el valor del préstamo por el número de cuotas
      cuota = valorPrestamo / numeroDeCuotas;
  } else {
      // Fórmula de amortización estándar
      cuota = valorPrestamo * (tasaInteresPeriodica / (1 - Math.pow(1 + tasaInteresPeriodica, -numeroDeCuotas)));
  }

  // Redondea la cuota al múltiplo de 100 más cercano
  return Math.ceil(cuota / 100) * 100;
}


searchSimpleCostosAdicionales(cantidadafnSimple:any){
  setTimeout(async () => {
      if(cantidadafnSimple!== undefined && cantidadafnSimple.value !== undefined && Number(cantidadafnSimple.value)==0 || isNaN(cantidadafnSimple.value) ){
       return
     }

     let cantidadInput = cantidadafnSimple.value;

      if (isNaN(cantidadInput)) {
        cantidadInput = 0;
        return
      }

     let cantidad = Number(cantidadInput)

     let costosAdicionales = Number(cantidad)
     this.generarCostosAdicionales(this.costosAdicionales)
     return
   },1000)
  }

  generarCostosAdicionales(valor: number) {
    this.costosAdicionalesArray = []
    for (let i = 1; i <= valor; i++) {
      this.costosAdicionalesArray.push({ numeroDeCuota: i, montoDeLaCuota: 0, nombrecostoadicional:'' });
    }
  }

  async searchSimpleCostosAdicionalesArray(){
 }

 togglePlanSepare() {
  this.planSepare = this.planSepare === 'N' ? 'S' : 'N';
  if(this.planSepare === 'N') {
    this.planSepareTexto = 'NO'
  } else {
    this.planSepareTexto = 'SI'
  }
  this.planDePagos.next([])
  this.cdr.detectChanges();
  this.buscarIntereses(this.companiasId,this.valorCuota,12)
}
cambiarCheckPlanSepare(){
  this.CheckPlanSepare = !this.CheckPlanSepare
}

async onPeriodicidadWithInteresChange(event: any) {

  if(typeof(event) !== 'number') {
    this.periodicidad = event
    let calcularValorSegunPeriodicidad = await this.simuladorCuentasPorCobrarProvider.calcularValorSegunPeriodicidad(event)
    this.buscarIntereses(this.companiasId, this.valorTotalVenta,calcularValorSegunPeriodicidad)
    this.costosAdicionalesHeaders = []
    this.planDePagos.next([])
    this.cdr.detectChanges();
    }
  }

  async onDiaDePagoInteresesChange(event: any) {
    let cantidad = Number(this.numeroDeCuotas)
    this.cuotasExtrasArray = []
    this.cuotasExtras = 0
    this.costosAdicionalesRecalcular = []
    if (this.planDePagosConCostosAdicionalesCalculados.length>0) {
        this.costosAdicionalesRecalcular = this.planDePagosConCostosAdicionalesCalculados.filter((item)=>item.numeroCuota === this.selectedValue[0].numeroCuota)
    }
    const periodicidad = this.simuladorCuentasPorCobrarProvider.devolverNumeroDePeriodicidad(this.periodicidad);
    let selectedValue = this.selectedValue[0]
    await this.calcularPlanDePagosConIntereses(selectedValue, this.valorCuota, this.costosAdicionalesRecalcular, periodicidad,this.diaDePago)
    this.cdr.detectChanges();
  }

  async onCuotaChangeExonerarSelect(event: any) {
    if(this.exonerar === 'N') {
      this.utils.mensajeMuestro('Exonerar cuota',"El campo en Exonerar interes primeras cuotas debe estar en SI ",'warning')
      return
    } else {
      this.exoneradoNumeroCuotas = event !== undefined &&  event.numeroCuota ? event.numeroCuota : this.exoneradoNumeroCuotas;
    }
  }

  getDatosCreditos(): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        const datosCreditos = localStorage.getItem('datosCreditos');
        if (datosCreditos) {
          resolve(JSON.parse(datosCreditos)); // Resolver si hay datos
        } else {
          resolve(null); // Resolver como null si no hay datos
        }
      } catch (error) {
        reject(error); // Rechazar en caso de error
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/simulador-cuentas-por-cobrar/simulador-cuentas-por-cobrar.ts